/** Test-only override; null = use normal policy. */
let testOverride: boolean | null = null;

function isTestRuntime(): boolean {
  return (
    process.env.VITEST === "true" ||
    process.env.NODE_ENV === "test" ||
    process.env.JEST_WORKER_ID != null
  );
}

function isEnvBypass(): boolean {
  const flag = process.env.DISABLE_DISCOVERY_CACHE;
  return flag === "1" || flag === "true";
}

/** Whether discovery cache reads/writes are allowed (env + test policy only). */
export function isDiscoveryCacheEnabled(): boolean {
  if (testOverride !== null) return testOverride;
  if (isTestRuntime() || isEnvBypass()) return false;
  return true;
}

/** Vitest hooks: force cache on/off for tests that exercise cache behavior. */
export function setDiscoveryCacheEnabledForTests(enabled: boolean | null): void {
  testOverride = enabled;
}

export function resetDiscoveryCachePolicyForTests(): void {
  testOverride = null;
}
